import React, { useEffect } from 'react'
import { Result } from 'hooks/productSelector'
import { ResultItem } from './components/ResultItem'
import { Heading } from './styled'
import { useRecommendationContext } from 'app/livbrite/components/CustomerResults'
interface Props {
  resultsData: Result[]
}

export const Results: React.FC<Props> =({ resultsData }) => {
  const { fetchRecommendations } = useRecommendationContext()

  useEffect(() => {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
  }, [])

  useEffect(() => {
    fetchRecommendations()
  }, [resultsData, fetchRecommendations])

  return (
    <>
      <Heading>
        <h1>Survey Results</h1>
        <p>Based on your survey results here are some articles and products to help you navigate whats holding you back from achieving your goals. Click read more for articles. Click find products to help you find resources that help you get the most from everyday!</p>
      </Heading>
      <div>
        {resultsData?.map((result: Result) => {
          const { sku } = result
          return (
            <ResultItem key={sku} sku={sku} />
          )
        })}
      </div>
    </>
  )
}
